<template>
  <div
    class="text-link"
    :class="{ disable: disable, able: !disable }"
    @click="onClick"
  >
    {{ text }}
  </div>
</template>

<script>
export default {
  name: "text-link",
  props: {
    text: { type: String },
    disable: { type: Boolean, default: false },
  },
  methods: {
    onClick() {
      if (!this.disable) {
        this.$emit("click-text", this.text);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../../unified.scss";
.text-link {
  margin: 8px 0;
  text-align: center;
}
.able {
  color: #5cd5d6;
}
.disable {
  color: #c3c3c3;
}
</style>



// WEBPACK FOOTER //
// src/components/Atoms/TextLink.vue